export const PAYMENT_METHODS = {
    CARD: 'card',
    PAYPAL: 'paypal',
    SEPA: 'sepa',
    APPLE_PAY: 'applepay',
    GOOGLE_PAY: 'paywithgoogle',
}
